/* Elegance Coque — corrections 30-10 (liste des 100 points). Chargé sur tout le site par snippets/ec-fixes.liquid.
   1-2. Cartes en grille : mesure le bas du titre (--ec-mh) pour poser le cœur et l'œil hors de la photo, à côté du prix.
   44.  Prix affichés « 149 DH » au lieu de « 149.00 dh » (montants inchangés, simple mise en forme). */
(function () {
  if (window.__ec3010) { return; }
  window.__ec3010 = true;
  var d = document, W = window;

  /* ---------- cœur / œil sous la photo ---------- */
  function place() {
    /* lectures groupées, puis écritures : aucune mise en page forcée carte par carte */
    var cards = [].slice.call(d.querySelectorAll('.lcard')), plan = [];
    cards.forEach(function (c) {
      if (c.closest('.ectb-list')) { plan.push([c, null]); return; }
      var m = c.querySelector('.lcard__name') || c.querySelector('.lcard__media');
      if (!m || !m.offsetHeight) { return; }
      plan.push([c, Math.round(m.offsetTop + m.offsetHeight) + 'px']);
    });
    plan.forEach(function (p) {
      var c = p[0], v = p[1];
      if (v === null) { if (c.hasAttribute('data-ec-mh')) { c.removeAttribute('data-ec-mh'); c.style.removeProperty('--ec-mh'); } return; }
      if (c.style.getPropertyValue('--ec-mh') !== v) { c.style.setProperty('--ec-mh', v); }
      if (!c.hasAttribute('data-ec-mh')) { c.setAttribute('data-ec-mh', ''); }
    });
  }

  /* ---------- prix « 149 DH » ---------- */
  var PRICE = '.lcard__price,.ec-p__price,.lwl-card__price,.ecqv__pr,.ecb-card__price,.lau__price,.lcg-card__price,.lac-card__price,.lmk-p__price,.ecp-rec__p,.price,.price-item,product-price';
  var RE = /(\d{1,3}(?:[,   ]\d{3})+|\d+)[.,](\d{2})\s*(?:dh|mad)\b/gi;
  function fmtText(t) {
    return t.replace(/\bDh\s+(?=\d[\d,.   ]*\s*MAD\b)/g, '').replace(RE, function (_, w, dec) {
      var whole = w.replace(/[,   ]/g, '');
      whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return whole + (dec !== '00' ? ',' + dec : '') + ' DH';
    });
  }
  function prices(root) {
    [].forEach.call((root || d).querySelectorAll(PRICE), function (el) {
      var w = d.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) {
        if (!/\d[.,]\d{2}\s*(dh|mad)/i.test(n.nodeValue)) { continue; }
        var nv = fmtText(n.nodeValue);
        if (nv !== n.nodeValue) { n.nodeValue = nv; }
      }
    });
  }

  var t = 0;
  /* Polo simplifiée (.emrq--simple) : toujours la grille 2 / 4 colonnes, sans barre « Filtrer » */
  function simple() {
    [].forEach.call(d.querySelectorAll('.emrq--simple .ectb-list'), function (u) { u.classList.remove('ectb-list'); });
  }
  function run() { simple(); place(); prices(); }
  function later() { W.clearTimeout(t); t = W.setTimeout(run, 90); }
  function boot() {
    run();
    if (W.MutationObserver) {
      new MutationObserver(later).observe(d.body, { childList: true, subtree: true, characterData: true });
    }
    W.addEventListener('resize', later);
    /* changement grille / liste, filtres : après chaque clic */
    d.addEventListener('click', function () { W.setTimeout(later, 60); }, true);
    W.addEventListener('load', run);
    d.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG') { later(); } }, true);
  }
  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  W.addEventListener('pageshow', function (e) { if (e.persisted) { run(); } });
})();
